import script from "./AppContact.vue?vue&type=script&setup=true&lang=js"
export * from "./AppContact.vue?vue&type=script&setup=true&lang=js"

import "./AppContact.vue?vue&type=style&index=0&id=bf2052e8&lang=scss"

const __exports__ = script;

export default __exports__